<template>
  <div id="risco-cardiovascular" class="row">
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      :reset="nivelSelecionado"
                      @onChangeCheckbox="handleFilterChange"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="risco-cardiovascular"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import { chartOptions, dataFields, infoHtml } from './utils.js'
import TitleTag from '@/components/TitleTag.vue'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'RiscoCardiovascular',
  components: {
    Subtitle,
    Loader,
    apexchart: VueApexCharts,
    TitleTag,
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      cadastros: [],
      loadingLista: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      nivelSelecionado: null,
      text: infoHtml,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    filtros(selectedCheckbox) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      // Filtra os dados com base no checkbox selecionado
      if (selectedCheckbox) {
        data = Functions.exibirItensComNivel(data, selectedCheckbox)
      }
      this.cadastros = data
    },

    handleFilterChange(selectedCheckbox) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.nivelSelecionado = selectedCheckbox
      this.filtros(this.nivelSelecionado)
    },

    async buscarDadosIniciais() {
      try {
        let equipe = this.$store.state.equipesV2.find((el) => {
          return el.ine_esf_eap == this.$store.state.nu_ine
        })
        if (equipe) {
          this.equipe = {
            ine_esf_eap: equipe.ine_esf_eap,
            ine_esb: equipe.ine_esb,
            no_equipe: equipe.no_esb,
          }
        }

        this.loadingLista = true
        let response = await Functions.getCadastrosIndividuaisPorMicroArea(
          this.$store.state.cod_ibge,
          this.$store.state.nu_ine,
          this.$store.state.micro_area
        )
        if (response) {
          this.cadastrosOriginais = response
          this.cadastros = response
          this.filtros(this.nivelSelecionado)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLista = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.$store.state.micro_area
      )
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped lang="scss">
.select-situacao {
  margin: 10px;
  min-width: 210px;
}
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
#atendimento-hipertensao .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#atendimento-hipertensao .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#atendimento-hipertensao .select-situacao .v-select {
  width: 296px;
}
#atendimento-hipertensao .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
<style>
.resultado-atendimento-hipertensao {
  cursor: pointer;
  display: flex;
  padding: 10px 1rem;
  gap: 15px;
  font-size: 20px;
  color: black;
  background: white;
  justify-content: flex-end;
  padding-bottom: 5px;
}
.resultado-atendimento-hipertensao .esus-feedback-tabs ul li .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.resultado-atendimento-hipertensao .esus-feedback-tabs ul li .nav-link.active {
  color: #0056b3 !important;
  border-color: unset !important;
  border-bottom: unset;
  border: unset;
}
.resultado-atendimento-hipertensao .nav-tabs {
  border-bottom: unset;
}
</style>
